module.exports = __webpack_public_path__ + "img/aej1n-66wvl.013.dcc99885.png";